import { render, staticRenderFns } from "./TipoContactoModalEdicion.vue?vue&type=template&id=4225d315&scoped=true&"
import script from "./TipoContactoModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./TipoContactoModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./TipoContactoModalEdicion.vue?vue&type=style&index=0&id=4225d315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4225d315",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4225d315', component.options)
    } else {
      api.reload('4225d315', component.options)
    }
    module.hot.accept("./TipoContactoModalEdicion.vue?vue&type=template&id=4225d315&scoped=true&", function () {
      api.rerender('4225d315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoContacto/TipoContactoModalEdicion.vue"
export default component.exports